'use strict';

var dateFns = require('date-fns');
var getLocaleData = require('../utils/getLocaleData.cjs');

const DEFAULT_MONTH_FORMAT = "MMMM";
const YEAR = 9999;
const DATE = 1;
function formatMonthWithLocale({
  month,
  localesType,
  format = DEFAULT_MONTH_FORMAT
}) {
  const dateFnsLocaleData = getLocaleData(localesType);
  return dateFns.format(new Date(YEAR, month - 1, DATE), format, {
    locale: dateFnsLocaleData
  });
}

module.exports = formatMonthWithLocale;
//# sourceMappingURL=formatMonthWithLocale.cjs.map
